import { formatDateHHMM } from "../../../../../../../../utils/date";
import { useWalletLogContext } from "../../../../../hooks/wallet-log-context";
import { checkPointLogType } from "../../../utils/log-type";
import {
  WalletLogsListRow,
  WalletLogListDate,
  WalletLogsListItemWrapper,
  WalletLogsListItem,
  WalletLogsListItemInfo,
  WalletLogsRowBorder,
} from "../style";

const WalletLogsPointList = () => {
  const { pointLogs } = useWalletLogContext();

  const formatDate = (value: string) => {
    const [_, month, day] = value.split("-");
    return `${month}.${day}`;
  };

  return (
    <>
      {pointLogs.map((item, index) => (
        <>
          <WalletLogsListRow key={index}>
            <WalletLogListDate>{formatDate(item.date)}</WalletLogListDate>
            <WalletLogsListItemWrapper>
              {item.list.map((log, i) => (
                <WalletLogsListItem key={i}>
                  <WalletLogsListItemInfo>
                    <div className="info">
                      {log.pubName}{" "}
                      {checkPointLogType(log.actionType, log.point)
                        ? "지급"
                        : "차감"}
                    </div>
                    <div className="date">
                      {formatDateHHMM(log.createdAt.toString())}
                    </div>
                  </WalletLogsListItemInfo>
                  <div className="point">
                    {checkPointLogType(log.actionType, log.point) ? "+" : "-"}
                    {log.point?.toLocaleString()} E
                  </div>
                </WalletLogsListItem>
              ))}
            </WalletLogsListItemWrapper>
          </WalletLogsListRow>
          <WalletLogsRowBorder />
        </>
      ))}
    </>
  );
};

export default WalletLogsPointList;
